<template>
  <div>
    <!-- 活动标题 -->
    <div v-wechat-title='"梦境携行-组队得百抽奖励"'></div>

    <div class="help-page-bc">

    <header :class="'header-login-' + headerLogin">
      <div class="acco">{{ isUserInfo.account }}</div>
      <a class="download-btn" :href="downloadUrl" title="下载按钮" @click="loggerCount('小樱_百抽H5_点击下载按钮')"></a>
      <a v-if="isUserInfo.account == ''" class="logon-btn" @click="logon()" title="登录&切换按钮" href="javascript:;"></a>
      <a v-else href="javascript:;" class="switch-btn" @click="switchBtn()"></a>
    </header>

    <!-- 登录弹窗 -->
    <Login v-if='isShowLogin'
      v-on:channelCallback='selectCallback'
      :gameName="gameName"
      :downloadUrl="downloadUrl"
      :loginTypes="loginTypes"
      :autoOpenOS="false"
      channelTips="角色ID可在游戏中—信息查看"></Login>
    <Os v-if='isShowOs'
      v-on:selectCallback='selectCallback'
      v-on:logoutCallback='osCancell'
      :gameName="gameName"></Os>

      <div class="title">
        <transition enter-active-class="animated fadeInUp" leave-active-class="animated fadeOut" name="fade">
          <img v-show="titleShow" src="https://download4.qcplay.com/h5-images/assets/images/active/sakura/lottery/title_img.png"/>
        </transition>
      </div>
      <div class="invite-title">
        {{invite_account}}{{ inviteFont }}</div>
      <div class="btn-box">
        <a href="javascript:;" class="new-team-btn" @click="newTeam()" title="另创队伍"></a>
        <a href="javascript:;" class="agree-join-btn" @click="agreeJoin()" title="同意加入"></a>
      </div>
    </div>

    <!-- 是否确认创立搜索小队 -->
    <div class="establish-wrap popup_wrap" v-show="establishShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="establish-box popup_wrap-box" v-show="establishShow">
          <a class="close-btn" href="javascript:;" @click="establishShow = false"></a>
          <a class="determine-btn" href="javascript:;" @click="goHome()"></a>
        </div>
      </transition>
      <div class="close-bg" @click="establishShow = false"></div>
    </div>

    <div class="establish-wrap-2 popup_wrap" v-show="establishShow2">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="establish-box popup_wrap-box" v-show="establishShow2">
          <a class="close-btn" href="javascript:;" @click="establishShow2 = false"></a>
          <a class="determine-btn" href="javascript:;" @click="addTeam()"></a>
        </div>
      </transition>
      <div class="close-bg" @click="establishShow2 = false"></div>
    </div>

    <!-- 成功加入小队 -->
    <div class="added-success-wrap popup_wrap" v-show="addedSuccessShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="added-success-box popup_wrap-box" v-show="addedSuccessShow">
          <a class="link-btn" href="javascript:;" @click="goHome()"></a>
        </div>
      </transition>
      <div class="close-bg" @click="addedSuccessShow = false"></div>
    </div>

    <!-- 很抱歉，您已经入队了！ -->
    <div class="noNeed-team-up-wrap popup_wrap" v-show="noNeedShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="noNeed-team-up-box popup_wrap-box" v-show="noNeedShow">
          <a class="link-btn" href="javascript:;" @click="goHome()"></a>
        </div>
      </transition>
      <div class="close-bg" @click="noNeedShow = false"></div>
    </div>

    <!-- 很抱歉，该队伍已经满员了 -->
    <div class="full-wrap popup_wrap" v-show="fullShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="full-box popup_wrap-box" v-show="fullShow">
          <a class="link-btn" href="javascript:;" @click="goHome()"></a>
        </div>
      </transition>
      <div class="close-bg" @click="fullShow = false"></div>
    </div>

    <!-- 已在队伍中，无需重复加入 -->
    <div class="existed-wrap popup_wrap" v-show="existedShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="existed-up-box popup_wrap-box" v-show="existedShow">
          <a class="link-btn" href="javascript:;" @click="goHome()"></a>
        </div>
      </transition>
      <div class="close-bg" @click="existedShow = false"></div>
    </div>

    <!-- 注销弹窗 -->
    <div class="logout-wrap popup_wrap" v-show="logoutShow">
      <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight" :duration="{ enter: 1000 }">
        <div class="logout-box popup_wrap-box" v-show="logoutShow">
          <p>是否退出当前账号</p>
          <a class="left-btn" href="javascript:;" @click="logoutShow = false">取消</a>
          <a class="right-btn" href="javascript:;" @click="logoutBtn()">确定</a>
        </div>
      </transition>
    </div>

  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import { mapState, mapMutations, mapActions } from 'vuex';
import Os from '@/components/os';
import Login from '@/components/login';
import { onHelpGetInitDataAPI, onHelpJoinTeamAPI, onLogoutApi } from '../api';
import { getTimeStamp, buriedLogger, getRandomString, analysisParams } from '@/utils/utils';
export default {
  name: 'lottery',
  components: {
    Login,
    Os,
  },
  data () {
    return {
      gameName: 'sakura',
      logger: null,
      downloadUrl: 'https://sakura.qingcijoy.com/',
      titleShow: false,
      headerLogin: false,
      establishShow: false,
      establishShow2: false,
      addedSuccessShow: false,
      noNeedShow: false,
      existedShow: false,
      fullShow: false,
      logoutShow: false,
      friendId: '',
      invite_account: '',
      isActivity: '',
      isUserInfo: {
        account: '',
        game_id: '',
        role_id: '',
        role_name: '',
        server_id: '',
        server_name: '',
      },
      invalidTeaming: '',
      inviteFont: '邀请您加入TA的队伍',
      // 其他数据
      loginTypes: ['sms', 'password'],
    };
  },
  created () {
    const { protocol, host } = window.location;
    const params = analysisParams(window.location.href);
    this.friendId = params.friend_id;
    console.log(this.friendId);
    
    // 帮助页面初始化
    this.onHelpIntState();

    // 埋点
    const bl = buriedLogger('sakura', '小樱_百抽H5活动_助力页');
    this.logger = bl
  },
  mounted () {
    this.$nextTick(() => {
      this.monitoringEquipment();
    })
  },
  computed: {
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  watch: {
    userInfo: {
      handler (newValue, oldValue) {
        console.log('newValue', newValue);
        console.log('oldValue', oldValue);
        if (!newValue.account) {
          // TAG: 注销的时候
        } else if (newValue.account !== oldValue.account) {
          // TAG: 初始登陆/切换角色的时候
          this.onHelpIntState();
        }
      }
    }
  },
  methods: {
    monitoringEquipment () {
      if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) location.href = `https://h5.qingcigame.com/sakura/lottery/pc${getTimeStamp()}`
    },
    // 登录弹窗
    logon() {
      this.changeLoginPopup(true);
      this.logger.sum('小樱_百抽H5_点击头部登录按钮');
    },
    switchBtn() {
      this.logoutShow = true;
      this.logger.sum('小樱_百抽H5_点击头部切换录按钮');
    },
    onHelpIntState() {
      onHelpGetInitDataAPI({friend_id: this.friendId}).then(response => {
        const { code } = response || {}
        this.inviteFont = response.message;
        this.titleShow = true;
        if (Number(code) === 200) {
          this.setActivity(response.data.activity);
          this.setUserinfo(response.data.user_info);
          this.inviteFont = '邀请您加入TA的队伍';
          this.logger.sum('小樱_百抽H5_队伍加入成功');
          return
        }
        if (Number(code) === 403) {
          this.changeLoginPopup(true);
          return      
        }
        this.onToast(response.message);
      });
    },
    // 活动内容
    setActivity(data) {
      this.isActivity = data;
      if(this.isActivity.is_my_team == true) {
        this.goHome();
      } else {
        this.invite_account = this.isActivity.invite_account.substr(-4);
        this.headerLogin = true;
      }
    },
    // 个人信息
    setUserinfo(data) {
      this.isUserInfo = data;
    },
    // 成立小队
    newTeam() {
      if (this.isUserInfo.account === undefined || this.isUserInfo.account === '') {
        this.changeLoginPopup(true);
      } else {
        if(this.invalidTeaming || this.isActivity.is_join) {
          this.noNeedShow = true;
        } else {
          // this.establishShow = true;
          this.goHome();
        }
      }
    },
    // 同意加入小队
    agreeJoin() {
      if (this.isUserInfo.account === undefined || this.isUserInfo.account === '') {
        this.changeLoginPopup(true);
      } else {
        this.establishShow2 = true;        
      }      
    },
    // 加入小队
    addTeam() {
      onHelpJoinTeamAPI({friend_id: this.friendId}).then(response => {
        const { code } = response || {}
        this.establishShow2 = false;
        if (Number(code) === 200) {
          this.addedSuccessShow = true;
          return
        }
        if (Number(code) === 406) {
          this.noNeedShow = true;
          this.invalidTeaming = true;
          return
        }
        // 很抱歉，该队伍已经满员了
        if (Number(code) === 408) {
          this.fullShow = true;
          return
        }
        this.onToast(response.message);
      });
    },
    goHome() {
      this.logger.sum('小樱_百抽H5_点击参与按钮前往活动页面');
      const { protocol, host } = window.location;
      setTimeout(() => {
        window.location = `${protocol}//${host}/sakura/lottery/enter${getRandomString()}`;
      }, 250);
    },
    // 账号注销按钮
    logoutBtn() {
      onLogoutApi().then(response => {
        const { code } = response || {}
        if (Number(code) === 200) {
          this.onHelpIntState();
          this.clearData();
        }
      });
    },
    // 数据清除
    clearData() {
      // this.isActivity = '';
      // this.isUserInfo = '';
      this.isUserInfo.account = '';
      this.isActivity.is_create = '';
      this.isActivity.is_first = '';
      this.isActivity.is_join = '';
      this.isActivity.reward_list = '';      
      this.isActivity.user_id = 0;
      this.isActivity.team_data = [
        {nick_name : 0},
        {nick_name : 0},
        {nick_name : 0}
      ];      
      this.isUserInfo.account = '';
      this.isUserInfo.game_id = '';
      this.isUserInfo.role_id = '';
      this.isUserInfo.role_name = '';
      this.isUserInfo.server_id = '';
      this.isUserInfo.server_name = '';
      this.accountId = '';
      this.clipInfo = '';
      this.invite_account = '';
      this.progress = 0;
      this.logoutShow = false;
      this.headerLogin = false;
      this.invalidTeaming = false;      
    },
    // 选择角色后
    selectCallback () {
      onGetInitDataAPI().then(response => {
        this.onInitDataCallback(response);
      });
    },
    // 埋点记录
    loggerCount(info) {
      this.logger.sum(info);
    },
    // TAG: 其他简易封装的方法
    onToast (config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },
    ...mapMutations([
      'changeLoginPopup',
      'changeOsPopup',
      'setInitActiveInfo',
      'setInitUserInfo',
      'setLogger'
    ]),
    ...mapActions([
      'onInitDataCallback',
      'onCount',
      'setShare'
    ])

  }
};
</script>

<style lang='less' scoped>
  @import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/sakura/lottery/help/index.vue